import React from 'react';

const BrandingBenefits = () => {
  const benefits = [
    { title: "Instant Brand Recognition", description: "A unique brand helps you stand out" },
    { title: "Builds Customer Trust", description: "A professional brand boosts credibility" },
    { title: "Consistent Marketing Message", description: "Ensures uniformity across all platforms" },
    { title: "Increases Customer Engagement", description: "A well-crafted brand creates emotional connections" },
    { title: "Drives Business Growth", description: "A strong brand enhances sales & customer loyalty" }
  ];

  return (
    <div className="bg-black py-12 px-4 rounded-lg text-white">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl font-bold mb-8 flex items-center">
          <span className="bg-yellow-500 p-2 rounded-full mr-3 text-xl text-black">!</span>
          Why Branding is Essential for Your Business
        </h2>
        
        <div className="space-y-4">
          {benefits.map((benefit, index) => (
            <div key={index} className="flex items-start p-4 rounded-lg border border-yellow-500">
              <span className="text-yellow-500 mr-3 font-bold text-xl">✓</span>
              <div>
                <h3 className="font-bold text-yellow-500">{benefit.title}</h3>
                <p className="text-gray-300">{benefit.description}</p>
              </div>
            </div>
          ))}
        </div>
        
        <div className="text-center mt-8">
        </div>
      </div>
    </div>
  );
};

export default BrandingBenefits;